import { render } from "preact";
import * as Sentry from "@sentry/react";
import { configureRuntime } from "@core/runtime/runtime";
import { App } from "./App";
import { ContentData as RawContentData } from "./data/data";
import { setContentData } from "./contentRegistry";
import OnboardingBg from "./assets/images/onboading-bg.webp";

// Preload the in-AR onboarding background so it's cached by the time the modal
// renders after the user taps Launch AR.
const preloadLink = document.createElement("link");
preloadLink.rel = "preload";
preloadLink.as = "image";
preloadLink.href = OnboardingBg;
document.head.appendChild(preloadLink);

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://c29f3e261fa0bb0f74dee0087ed17f97@o1388406.ingest.us.sentry.io/4511459893051392",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}

configureRuntime({
  load: async () => {
    // Resolve panel refs (fetch creator JSON + expand scene config) before AR
    const { resolvePanelsInContent } = await import(
      "@core/content/creator/PanelResolver"
    );
    const resolved = await resolvePanelsInContent(RawContentData, {
      positionMode: "placing",
    });
    setContentData(resolved as typeof RawContentData);

    const { appReady } = await import("./main.app");
    await appReady;
  },
});

const appElement = document.getElementById("app");
if (appElement) {
  render(<App />, appElement);
}
